export default __webpack_public_path__ + "static/media/tw.3041fae2.svg";